'use client';

import * as React from 'react';
// import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils';
// import { cva, VariantProps } from 'class-variance-authority';

// const labelVariants = cva(
//   'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
// );

// export interface LabelProps
//   extends React.LabelHTMLAttributes<HTMLLabelElement> {}

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className
      )}
      {...props}
    />
  )
);
Label.displayName = 'Label';

export { Label }; 